import React, { useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import { BsClock } from "@react-icons/all-files/bs/BsClock";

import Image from "next/image";
import Remote from "../LoaderRemote";
import Sidebar from "../BlogList/Sidebar";
import { useRouter } from "next/router";
import styles from "../../styles/BlogDetail.module.css";
import { useTranslation } from "../../context/TranslationContext";

const BlogDetail = ({ ssr, isAppWebView }) => {
  const { blogPage } = useTranslation();
  const page = ssr.result;
  const router = useRouter();

  const SearchOnSubmit = (SearchText) => {
    const { query } = router;
    query.slug = [blogPage.url];
    if (SearchText) {
      query.search = SearchText;
    } else {
      delete query.search;
    }
    router.replace({
      query: query,
    });
  };

  return (
    <>
      <BreadCrumb data={ssr.result.BreadCrumb} isAppWebView={isAppWebView} />
      <div className="Blog_detail">
        <div className="container">
          <div className="grid grid-cols-12 gap-x-8">
            <div className="lg:col-span-8 col-span-12">
              <div className="item-img mb-4 relative">
                <div className="w-full h-96 rounded-lg relative">
                  {page.resim && (
                    <Image
                      loader={Remote}
                      src={page.resim}
                      layout={"fill"}
                      objectFit={"cover"}
                      objectPosition={"center"}
                      alt={page.title}
                    ></Image>
                  )}
                </div>
                {/* <div className="ribbon absolute top-0 right-4 me-3 mt-3 font-medium rounded-3xl bg-white  hover:bg-black hover:text-white  py-2 px-3 text-15 ease-linear duration-300">
                  <a href="#" className="">
                    Tarihsel Gezi Rehberi
                  </a>
                </div> */}
              </div>
              <div className="inc-header">
                <div className="flex flex-row items-center pb-2">
                  {/* <div className="flex flex-row items-center opacity-50  mt-1 mr-3">
                    <BsBarChart />
                    <span className="text-tiny pl-2">2 saat önce</span>
                  </div> */}
                </div>
                <span className="text-25 font-semibold mb-3">
                  {page.baslik}
                </span>
                <div
                  className={`font-normal text-15 ` + styles.Content}
                  dangerouslySetInnerHTML={{ __html: page.icerik }}
                ></div>
              </div>
            </div>
            <Sidebar
              SearchOnSubmit={SearchOnSubmit}
              LastShared={page.LastShared}
              Popular={page.Popular}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
